export default "__VITE_ASSET__BAK6VAyA__"